import MasterPage from "./MasterPage";

function Page({ iD, title, content, pageHeader }) {
    return <MasterPage pageID={iD} pageName={title} bodyContent={content} pageHeader={pageHeader}  />
}

export default Page;